import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connectStore } from "redux-box";
import { module as inviteCode } from "@st/inviteCode";
import { module as product } from "@st/product";
import { module as onboard } from "@st/onboard";
import Select from "react-select";
import CheckBox from "./CheckBox";
import {
  DropDownContainer,
  DropDownTitle,
  DatePickerContainer,
} from "./SchoolIroEnable.styled";
import { Th, Td, Tr, Table } from "./SchoolIroEnable.styled";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
  DateSelector,
  DateSelectorIcon,
} from "../../flive-code-view/renewalold-school/RenewalOldSchool.styled";
import userApi from "../../../services/api/user";
import { MOCK_ASSESSMENT_ID } from "../../../utils/constant";
import Tree from "rc-tree";
import 'rc-tree/assets/index.css';

const userTypes = [
  { label: "Students", value: "students" },
  { label: "Teachers", value: "teachers" },
  { label: "Both", value: "both" },
];

const examSections = [
  { label: "Reading Comprehension", value: "Reading Comprehension" },
  { label: "Full Assessment", value: "Full Assessment" },
];

function SchoolIroEnable(props) {
  const [gradeOption, setGradeOption] = useState([]);
  const [schoolIroEnableData, setSchoolIroEnableData] = useState({
    isEnableSchoolIro: false,
    school: null,
    selectedGrades: [],
    examDatesTable: [],
    test_id: "",
    examStatus: null,
    user_type: "",
    selectedSections: [],
    exam_section: "",
    start_date: "",
    end_date: "",
  });

  const [examOptions, setExamOptions] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);

  useEffect(() => {
    let { schoolEditInfo } = props.inviteCode;
    if (schoolEditInfo) {
      setSchoolIroEnableData((prev) => ({
        ...prev,
        school: schoolEditInfo.id,
      }));
      props.inviteCode.getSchoolIro(schoolEditInfo.id);
    }
    props.inviteCode.getAllGrades();
    if (!props.inviteCode.iroExamTypes || props.inviteCode.iroExamTypes.length === 0) {
      props.inviteCode.getIroExamTypes();
    }
  }, []);

  useEffect(() => {
    let gradesList = props.inviteCode.allGrades.map((grade) => ({
      value: grade.id,
      label: grade.name,
    }));
    setGradeOption(gradesList);
  }, [props.inviteCode.allGrades]);

  useEffect(() => {
    if (props.inviteCode.iroExamTypes && props.inviteCode.iroExamTypes.length > 0) {
      let updatedTypes = props.inviteCode.iroExamTypes
        .filter((exam) => exam.id !== MOCK_ASSESSMENT_ID)
        .map((type) => ({
          label: type.name,
          value: type.id,
        }));
      setExamOptions(updatedTypes);
    }
  }, [props.inviteCode.iroExamTypes]);

  useEffect(() => {
    let schoolIro = props.inviteCode.schoolIro;
    if (!schoolIro) return;

    let resultsList = [];
    if (Array.isArray(schoolIro)) {
      resultsList = schoolIro;
    } else if (schoolIro && Array.isArray(schoolIro.result)) {
      resultsList = schoolIro.result;
    }

    if (resultsList && resultsList.length > 0) {
      setSchoolIroEnableData((prevData) => ({
        ...prevData,
        isEnableSchoolIro: true,
        examDatesTable: resultsList,
      }));
    }

    if (schoolIro && schoolIro.has_next && props.inviteCode.schoolEditInfo) {
      props.inviteCode.getSchoolIro(
        props.inviteCode.schoolEditInfo.id,
        schoolIro.next_page
      );
    }
  }, [props.inviteCode.schoolIro]);

  useEffect(() => {
    const fetchTreeData = async () => {
      let { school } = schoolIroEnableData;
      let nonEligibleGrades = ["Montessori", "Nursery", "Kindergarten"];

      if (!gradeOption.length > 0) return;

      const tree = [];

      for (let grade of gradeOption) {
        if (nonEligibleGrades.includes(grade.label)) {
          continue;
        }

        let data = {
          school: props.inviteCode.schoolEditInfo
            ? props.inviteCode.schoolEditInfo.id
            : school,
          grade: grade.value,
        };
        const res = await userApi.getSections(data);

        if (res && Object.keys(res).length > 0) {
          const gradeNode = {
            title: grade.label,
            key: `grade:${grade.value}`,
            children: res
              ? Object.keys(res).map((section) => ({
                  title: res[section],
                  key: section,
                  isLeaf: true,
                }))
              : [],
          };
          tree.push(gradeNode);
        }
      }

      setTreeData(tree);
    };

    fetchTreeData();
  }, [gradeOption, schoolIroEnableData.school]);

  const updateSchoolIroFormData = (data) => {
    props.inviteCode.setSchoolIroFormData(data);
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event && event.target ? event.target.checked : false;
    setSchoolIroEnableData((prev) => ({
      ...prev,
      isEnableSchoolIro: isChecked,
    }));
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const handleGradeSectionSelection = (checkedKeysObj) => {
    const { checked } = checkedKeysObj;

    const selectedGrades = [];
    const selectedSections = [];

    checked.forEach((key) => {
      if (key.startsWith("grade")) {
        const gradeId = key.split(":")[1];
        const gradeNode = treeData.find((g) => g.key === key);
        const sectionKeys = gradeNode
          ? gradeNode.children.map((c) => c.key)
          : [];

        const isAnyChildChecked = sectionKeys.some((sKey) =>
          checked.includes(sKey)
        );

        if (!isAnyChildChecked) {
          selectedGrades.push(gradeId);
        }
      } else {
        selectedSections.push(key);
      }
    });

    setCheckedKeys(checked);
    setSchoolIroEnableData((prev) => ({
      ...prev,
      selectedGrades,
      selectedSections,
    }));

    updateSchoolIroFormData({
      ...schoolIroEnableData,
      selectedGrades,
      selectedSections,
    });

    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const handleExamStartDate = (date) => {
    const formatted = moment(date).format("YYYY-MM-DD");
    const updated = {
      ...schoolIroEnableData,
      start_date: formatted,
    };
    setSchoolIroEnableData(updated);
    updateSchoolIroFormData(updated);
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const handleExamEndDate = (date) => {
    const formatted = moment(date).format("YYYY-MM-DD");
    const updated = {
      ...schoolIroEnableData,
      end_date: formatted,
    };
    setSchoolIroEnableData(updated);
    updateSchoolIroFormData(updated);
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const onDatepickerRef = (el) => {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  };

  const handleExamTypeChange = (e) => {
    const updated = {
      ...schoolIroEnableData,
      test_id: e.value,
    };
    setSchoolIroEnableData(updated);
    updateSchoolIroFormData(updated);
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const handleExamSectionSelection = (e) => {
    const updated = {
      ...schoolIroEnableData,
      exam_section: e.value,
    };
    setSchoolIroEnableData(updated);
    updateSchoolIroFormData(updated);
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const handleUserTypeChange = (e) => {
    const updated = {
      ...schoolIroEnableData,
      user_type: e.value,
    };
    setSchoolIroEnableData(updated);
    updateSchoolIroFormData(updated);
    if (props.schoolIroFormUpdated) {
      props.schoolIroFormUpdated();
    }
  };

  const formatGrades = (record) => {
    const gradeMap = {};

    if (record.school_class) {
      record.school_class.forEach(({ name, grade }) => {
        if (!gradeMap[grade]) gradeMap[grade] = new Set();
        gradeMap[grade].add(name);
      });
    }

    if (record.grade) {
      record.grade.forEach((grade) => {
        if (!gradeMap[grade]) gradeMap[grade] = new Set();
      });
    }

    const parts = Object.entries(gradeMap).map(([grade, sections]) => {
      if (sections.size > 0) {
        return `${grade} - ${Array.from(sections).join(", ")}`;
      }
      return grade;
    });

    return parts.join("; ");
  };

  return (
    props.inviteCode.schoolEditInfo && (
      <div className="mt-4">
        <div>
          <label>
            <CheckBox
              checked={schoolIroEnableData.isEnableSchoolIro}
              onChange={handleCheckboxChange}
              disabled={
                props.inviteCode.schoolEdit
                  ? !props.inviteCode.schoolEdit
                  : true
              }
            />
            <span style={{ marginLeft: 8 }}>Enable IRO</span>
          </label>
        </div>

        {schoolIroEnableData.isEnableSchoolIro && (
          <Table>
            <thead>
              <Tr className="text-center">
                <Th>Exam Date Range</Th>
                <Th>Exam Name</Th>
                <Th>Grades</Th>
                <Th>User Type</Th>
              </Tr>
            </thead>
            <tbody>
              {schoolIroEnableData.examDatesTable &&
              schoolIroEnableData.examDatesTable.length > 0 ? (
                schoolIroEnableData.examDatesTable.map((exam, index) => (
                  <Tr key={index}>
                    <Td
                      style={{ width: "30%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.start_date} to {exam.end_date}
                    </Td>
                    <Td
                      style={{ width: "20%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.test_name} <br /> {exam.exam_section}
                    </Td>
                    <Td
                      style={{ width: "35%", padding: "10px" }}
                      className="text-center"
                    >
                      {formatGrades(exam)}
                    </Td>
                    <Td
                      style={{ width: "15%", padding: "10px" }}
                      className="text-center"
                    >
                      {exam.user_type}
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={4} className="text-center">
                    No IRO exams enabled
                  </Td>
                </Tr>
              )}
            </tbody>
          </Table>
        )}

        {schoolIroEnableData.isEnableSchoolIro && (
          <div>
            <DropDownContainer>
              <DropDownTitle>EXAM TYPE</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select exam type"}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleExamTypeChange}
                options={examOptions.length > 0 ? examOptions : []}
                isMulti={false}
              />
            </DropDownContainer>

            <DropDownContainer>
              <DropDownTitle>EXAM SECTION</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select exam type"}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleExamSectionSelection}
                options={examSections}
                isMulti={false}
              />
            </DropDownContainer>

            <DropDownContainer>
              <DropDownTitle>USER TYPES</DropDownTitle>
              <Select
                styles={{
                  placeholder: (provided) => ({
                    ...provided,
                    color: "rgba(0, 0, 0, 0.2)",
                  }),
                }}
                placeholder={"select user type"}
                isDisabled={
                  props.inviteCode.schoolEdit
                    ? !props.inviteCode.schoolEdit
                    : true
                }
                onChange={handleUserTypeChange}
                options={userTypes}
                isMulti={false}
              />
            </DropDownContainer>

            <DropDownContainer>
              <DropDownTitle>SCHOOL GRADES</DropDownTitle>
              {/* <GradeSectionTree
                checkedKeys={checkedKeys}
                onCheck={handleGradeSectionSelection}
                treeData={treeData}
                disabled={!props.inviteCode.schoolEdit}
              /> */}
              <Tree
                checkable
                onCheck={(keys) => handleGradeSectionSelection(keys)}
                checkedKeys={checkedKeys}
                treeData={treeData}
                defaultExpandAll
                autoExpandParent={true}
                showIcon={false}
                checkStrictly={true}
                disabled={!props.inviteCode.schoolEdit}
              />
            </DropDownContainer>

            <div style={{ display: "flex", width: "100%" }}>
              <DatePickerContainer>
                <h6>Start Date</h6>
                <DateSelector
                  style={{ overflow: "hidden", border: "1px solid #a349c9" }}
                >
                  <DateSelectorIcon className="fa fa-calendar" />
                  <DatePicker
                    selected={
                      schoolIroEnableData.start_date
                        ? moment(schoolIroEnableData.start_date).toDate()
                        : null
                    }
                    selectsStart
                    startDate={
                      schoolIroEnableData.start_date
                        ? moment(schoolIroEnableData.start_date).toDate()
                        : null
                    }
                    onChange={handleExamStartDate}
                    minDate={moment().toDate()}
                    placeholderText="Select start date"
                    disabled={
                      props.inviteCode.schoolEdit
                        ? !props.inviteCode.schoolEdit
                        : true
                    }
                    ref={(el) => onDatepickerRef(el)}
                  />
                </DateSelector>
              </DatePickerContainer>
              &nbsp;
              <DatePickerContainer>
                <h6>End Date</h6>
                <DateSelector
                  style={{ overflow: "hidden", border: "1px solid #a349c9" }}
                >
                  <DateSelectorIcon className="fa fa-calendar" />
                  <DatePicker
                    selected={
                      schoolIroEnableData.end_date
                        ? moment(schoolIroEnableData.end_date).toDate()
                        : null
                    }
                    selectsStart
                    startDate={
                      schoolIroEnableData.end_date
                        ? moment(schoolIroEnableData.end_date).toDate()
                        : null
                    }
                    onChange={handleExamEndDate}
                    minDate={moment().toDate()}
                    placeholderText="Select end date"
                    disabled={
                      props.inviteCode.schoolEdit
                        ? !props.inviteCode.schoolEdit
                        : true
                    }
                    ref={(el) => onDatepickerRef(el)}
                  />
                </DateSelector>
              </DatePickerContainer>
            </div>
          </div>
        )}
      </div>
    )
  );
}

export default withRouter(
  connectStore({
    inviteCode,
    onboard,
    product,
  })(SchoolIroEnable)
);
